"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseRejected = exports.responseRejectedSSM = exports.requestTokenRefresh = exports.requestTokenRefreshSSM = exports.getNewAccessToken = exports.getCredentials = exports.getCredentialsFromSSM = exports.getParameters = exports.getParameter = exports.getInternalOAuthClientConfig = exports.token = void 0;
const axios_1 = __importDefault(require("axios"));
const client_ssm_1 = require("@aws-sdk/client-ssm");
const client_cognito_identity_provider_1 = require("@aws-sdk/client-cognito-identity-provider");
const assert_1 = require("@deliverr/commons-utils/lib/assert");
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const AWS_REGION = "us-east-1";
const token = (clientIdParameterName, clientSecretParameterName, userPoolDomain, clientId, clientSecret) => {
    let token = "";
    return async () => {
        const decoded = jsonwebtoken_1.default.decode(token);
        const now = new Date();
        if (decoded && typeof decoded !== "string" && decoded["exp?"] < now.valueOf() + 3e5) {
            return token;
        }
        const p = (0, exports.getNewAccessToken)(userPoolDomain, clientId, clientSecret)
            .then((response) => {
            token = response.data.access_token;
        })
            .catch(async () => {
            return (0, exports.getCredentialsFromSSM)(clientIdParameterName, clientSecretParameterName).then(async (credentials) => {
                clientId = credentials.clientId;
                clientSecret = credentials.clientSecret;
                return (0, exports.getNewAccessToken)(userPoolDomain, clientId, clientSecret).then((response) => {
                    token = response.data.access_token;
                });
            });
        });
        if (token === "") {
            await p;
        }
        return token;
    };
};
exports.token = token;
const getInternalOAuthClientConfig = (directCallerServiceName, env) => {
    const domainEnv = env === "prod" ? "production" : env;
    return {
        clientIdParameterName: `/${directCallerServiceName}/${env}/tf/COGNITO_INTERNAL_CLIENT_ID`,
        clientSecretParameterName: `/${directCallerServiceName}/${env}/tf/COGNITO_INTERNAL_CLIENT_SECRET`,
        accessTokenUrl: `https://deliverr-service-${domainEnv}.auth.${AWS_REGION}.amazoncognito.com/oauth2/token`,
    };
};
exports.getInternalOAuthClientConfig = getInternalOAuthClientConfig;
const getParameter = async (parameterName, withDecryption) => {
    const client = new client_ssm_1.SSMClient({ region: AWS_REGION });
    const command = new client_ssm_1.GetParameterCommand({
        Name: parameterName,
        WithDecryption: withDecryption,
    });
    const response = await client.send(command);
    (0, assert_1.assert)(!!response.Parameter, { message: `Expected to find parameter value at ${parameterName}.` });
    return response.Parameter;
};
exports.getParameter = getParameter;
const getParameters = async (parameterNames, withDecryption) => {
    var _a;
    const client = new client_ssm_1.SSMClient({ region: AWS_REGION });
    const command = new client_ssm_1.GetParametersCommand({
        Names: parameterNames,
        WithDecryption: withDecryption,
    });
    const response = await client.send(command);
    (0, assert_1.assert)(!!(((_a = response.Parameters) === null || _a === void 0 ? void 0 : _a.length) === parameterNames.length), {
        message: `Expected to find parameter values at ${parameterNames}.`,
    });
    return response.Parameters;
};
exports.getParameters = getParameters;
const getCredentialsFromSSM = async (clientIdParameterName, clientSecretParameterName) => {
    const parameters = await (0, exports.getParameters)([clientIdParameterName, clientSecretParameterName], true);
    const clientId = parameters[0];
    const clientSecret = parameters[1];
    (0, assert_1.assert)(!!clientId.Value, {
        message: `Expected "${clientIdParameterName}" parameter to have a 'Value'.`,
    });
    (0, assert_1.assert)(!!clientSecret.Value, {
        message: `Expected "${clientSecretParameterName}" parameter to have a 'Value'.`,
    });
    return {
        clientId: clientId.Value,
        clientSecret: clientSecret.Value,
    };
};
exports.getCredentialsFromSSM = getCredentialsFromSSM;
const getCredentials = async (userPoolId, clientName) => {
    var _a, _b, _c, _d;
    const idsp = new client_cognito_identity_provider_1.CognitoIdentityProvider({
        region: AWS_REGION,
    });
    let clients = await idsp.listUserPoolClients({
        UserPoolId: userPoolId,
        MaxResults: 60,
    });
    (0, assert_1.assert)(!!clients.UserPoolClients, { message: `Expected ${userPoolId} to have some clients, but found none.` });
    let client = clients.UserPoolClients.find((client) => client.ClientName === clientName);
    while (!client && clients.NextToken) {
        clients = await idsp.listUserPoolClients({
            UserPoolId: userPoolId,
            MaxResults: 60,
            NextToken: clients.NextToken,
        });
        (0, assert_1.assert)(!!clients.UserPoolClients, { message: `Expected ${userPoolId} to have some clients, but found none.` });
        client = clients.UserPoolClients.find((client) => client.ClientName === clientName);
    }
    (0, assert_1.assert)(!!client, {
        message: `Expected to find client with name ${clientName} but only found ${clients.UserPoolClients.map((c) => c.ClientName)}`,
    });
    const clientDesc = await idsp.describeUserPoolClient({
        UserPoolId: userPoolId,
        ClientId: client.ClientId,
    });
    return {
        clientId: (_b = (_a = clientDesc.UserPoolClient) === null || _a === void 0 ? void 0 : _a.ClientId) !== null && _b !== void 0 ? _b : "",
        clientSecret: (_d = (_c = clientDesc.UserPoolClient) === null || _c === void 0 ? void 0 : _c.ClientSecret) !== null && _d !== void 0 ? _d : "",
    };
};
exports.getCredentials = getCredentials;
const getNewAccessToken = async (userPoolDomain, clientId, clientSecret) => {
    return axios_1.default.post(`${userPoolDomain}/oauth2/token`, {}, {
        params: {
            grant_type: "client_credentials",
            client_id: clientId,
            client_secret: clientSecret,
        },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        auth: {
            username: clientId,
            password: clientSecret,
        },
    });
};
exports.getNewAccessToken = getNewAccessToken;
const requestTokenRefreshSSM = (newCredentials, newToken, userPoolDomain, clientIdParameterName, clientSecretParameterName, clientId, clientSecret) => {
    const requestTokenRefresh = async (config) => {
        var _a;
        if (!config.headers) {
            config.headers = {};
        }
        const token = (_a = config.headers.Authorization) === null || _a === void 0 ? void 0 : _a.split("Bearer ")[1];
        if (!token) {
            return config;
        }
        const decode = jsonwebtoken_1.default.decode(token);
        const now = new Date();
        if (decode && typeof decode !== "string" && decode["exp?"] - 3e5 > now.valueOf()) {
            let response;
            try {
                response = await (0, exports.getNewAccessToken)(userPoolDomain, clientId(), clientSecret());
            }
            catch (error) {
                const credentials = await (0, exports.getCredentialsFromSSM)(clientIdParameterName, clientSecretParameterName);
                newCredentials(credentials);
                response = await (0, exports.getNewAccessToken)(userPoolDomain, credentials.clientId, credentials.clientSecret);
            }
            newToken(response.data.access_token);
            config.headers.Authorization = `Bearer ${response.data.access_token}`;
            return config;
        }
        return config;
    };
    return requestTokenRefresh;
};
exports.requestTokenRefreshSSM = requestTokenRefreshSSM;
const requestTokenRefresh = (newCredentials, newToken, userPoolDomain, userPoolId, clientName, clientId, clientSecret) => {
    const requestTokenRefresh = async (config) => {
        var _a;
        if (!config.headers) {
            config.headers = {};
        }
        const token = (_a = config.headers.Authorization) === null || _a === void 0 ? void 0 : _a.split("Bearer ")[1];
        if (!token) {
            return config;
        }
        const decode = jsonwebtoken_1.default.decode(token);
        const now = new Date();
        if (decode && typeof decode !== "string" && decode["exp?"] - 3e5 > now.valueOf()) {
            let response;
            try {
                response = await (0, exports.getNewAccessToken)(userPoolDomain, clientId, clientSecret);
            }
            catch (error) {
                const credentials = await (0, exports.getCredentials)(userPoolId, clientName);
                newCredentials(credentials);
                response = await (0, exports.getNewAccessToken)(userPoolDomain, credentials.clientId, credentials.clientSecret);
            }
            newToken(response.data.access_token);
            config.headers.Authorization = "Bearer " + response.data.access_token;
            return config;
        }
    };
    return requestTokenRefresh;
};
exports.requestTokenRefresh = requestTokenRefresh;
const responseRejectedSSM = (newCredentials, newToken, retry, userPoolDomain, clientIdParameterName, clientSecretParameterName, clientId, clientSecret) => {
    const responseRejected = async (error) => {
        var _a;
        if (error.response) {
            const axiosError = error;
            if (!axiosError.config) {
                return Promise.reject(error);
            }
            if (((_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                let response;
                try {
                    response = await (0, exports.getNewAccessToken)(userPoolDomain, clientId(), clientSecret());
                }
                catch (error) {
                    const credentials = await (0, exports.getCredentialsFromSSM)(clientIdParameterName, clientSecretParameterName);
                    newCredentials(credentials);
                    response = await (0, exports.getNewAccessToken)(userPoolDomain, credentials.clientId, credentials.clientSecret);
                }
                newToken(response.data.access_token);
                axiosError.config.headers.Authorization = `Bearer ${response.data.access_token}`;
                return await retry(axiosError.config);
            }
            else {
                return Promise.reject(error);
            }
        }
        else {
            return Promise.reject(error);
        }
    };
    return responseRejected;
};
exports.responseRejectedSSM = responseRejectedSSM;
const responseRejected = (newCredentials, newToken, retry, userPoolDomain, userPoolId, clientName, clientId, clientSecret) => {
    const responseRejected = async (error) => {
        var _a;
        if (error.response) {
            const axiosError = error;
            if (!axiosError.config) {
                return Promise.reject(error);
            }
            if (((_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                let response;
                try {
                    response = await (0, exports.getNewAccessToken)(userPoolDomain, clientId, clientSecret);
                }
                catch (error) {
                    const credentials = await (0, exports.getCredentials)(userPoolId, clientName);
                    newCredentials(credentials);
                    response = await (0, exports.getNewAccessToken)(userPoolDomain, credentials.clientId, credentials.clientSecret);
                }
                newToken(response.data.access_token);
                axiosError.config.headers.Authorization = `Bearer ${response.data.access_token}`;
                return retry(axiosError.config);
            }
            else {
                return Promise.reject(error);
            }
        }
        else {
            return Promise.reject(error);
        }
    };
    return responseRejected;
};
exports.responseRejected = responseRejected;
//# sourceMappingURL=cognito.js.map